<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="el-form-wrap">
    <ykc-form-item label="配置电站" prop="configStationType">
      <ykc-radio
        :data="configStationTypeData"
        v-model="ruleForm.configStationType"
        @change="handleConfigStationTypeChange"></ykc-radio>
    </ykc-form-item>
    <ykc-form-item
      v-if="ruleForm.configStationType === '0'"
      label="选择电站"
      prop="selectedStationIds">
      <ykc-cascader
        class="station-cascader"
        v-model="ruleForm.selectedStationIds"
        :options="stationTreeData"
        :configSet="cascaderConfig"
        placeholder="请选择电站"
        :collapseTags="true"></ykc-cascader>
    </ykc-form-item>
    <ykc-form-item
      v-if="ruleForm.configStationType === '1'"
      label="导入电站"
      prop="importStationIds">
      <ykc-upload
        type="xlsx"
        :size="5"
        ref="upload"
        :checkInfo="{ typeMess: '文件格式错误，请重新导入', sizeMess: '文件大小不超过' }"
        @handleRemove="handleImportRemove"
        @handleChange="handleImportChange"
        :temText="linkText"
        :temhref="modelUrl"></ykc-upload>
      <div class="import-tip">请上传包含“电站编码”的 xlsx 文件</div>
      <div v-if="importError" class="import-error">{{ importError }}</div>
      <div v-if="importedCount > 0" class="import-info">已导入 {{ importedCount }} 个电站</div>
    </ykc-form-item>
    <BatchPriceEditor ref="ykcPrice"></BatchPriceEditor>
  </ykc-form>
</template>

<script>
  import BatchPriceEditor from './BatchPriceEditor.vue';
  import { chargeStrategy } from '@/service/apis';

  export default {
    name: 'ChargingPriceBatchAdjust',
    components: { BatchPriceEditor },
    data() {
      return {
        configStationTypeData: [
          { id: '0', name: '下拉多选' },
          { id: '1', name: '手动导入' },
        ],
        cascaderConfig: {
          label: 'name',
          value: 'id',
          children: 'subTree',
          multiple: true,
        },
        stationTreeData: [],
        importError: '',
        importedCount: 0,
        ruleForm: {
          configStationType: '0',
          selectedStationIds: [],
          importStationIds: [],
        },
        rules: {
          configStationType: [{ required: true, message: '请选择配置方式', trigger: 'change' }],
          selectedStationIds: [
            {
              validator: (rule, value, callback) => {
                if (this.ruleForm.configStationType === '0' && (!value || value.length === 0)) {
                  callback(new Error('请选择电站'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
          importStationIds: [
            {
              validator: (rule, value, callback) => {
                if (this.ruleForm.configStationType === '1' && (!value || value.length === 0)) {
                  callback(new Error('请导入电站'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
        },
      };
    },
    created() {
      this.fetchStationTree();
    },
    computed: {
      modelUrl() {
        return `${process.env.VUE_APP_OSS}/resource/电站导入模板.xlsx`;
      },
      linkText() {
        return '电站导入模板.xlsx';
      },
    },
    methods: {
      fetchStationTree() {
        chargeStrategy.findConfiguredCityStationTree({}).then(res => {
          this.stationTreeData = res || [];
        });
      },
      handleConfigStationTypeChange() {
        this.ruleForm.selectedStationIds = [];
        this.ruleForm.importStationIds = [];
        this.importError = '';
        this.importedCount = 0;
        if (this.$refs.upload) {
          this.$refs.upload.fileList = [];
        }
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate();
        });
      },
      handleImportRemove() {
        this.ruleForm.importStationIds = [];
        this.importError = '';
        this.importedCount = 0;
      },
      handleImportChange(file, fileList, isCheck) {
        this.importError = '';
        this.importedCount = 0;
        if (!isCheck) {
          return;
        }
        const formData = new FormData();
        const param = {
          file: file.raw,
        };
        Object.entries(param).forEach(([k, v]) => {
          formData.append(k, v);
        });
        chargeStrategy
          .importStations(formData)
          .then(res => {
            const stationIds = (res || []).map(id => String(id));
            this.ruleForm.importStationIds = stationIds;
            this.importedCount = stationIds.length;
            this.$refs.ruleForm.validateField('importStationIds');
          })
          .catch(error => {
            this.ruleForm.importStationIds = [];
            this.importedCount = 0;
            const desc =
              error && error.header && error.header.resultDesc
                ? error.header.resultDesc
                : '导入失败，请检查文件内容';
            this.importError = desc;
          });
      },
      getSelectedStationIds() {
        if (this.ruleForm.configStationType === '0') {
          const values = this.ruleForm.selectedStationIds || [];
          return values
            .filter(item => Array.isArray(item) && item.length)
            .map(item => String(item[item.length - 1]));
        }
        return this.ruleForm.importStationIds || [];
      },
      submitForm(callback) {
        Promise.all([
          new Promise(resolve => {
            this.$refs.ruleForm.validate(valid => {
              resolve(valid);
            });
          }),
          this.$refs.ykcPrice.saveVerifyOMP(),
        ]).then(res => {
          if (!res.every(valid => !!valid)) {
            return;
          }
          const stationIds = this.getSelectedStationIds();
          if (stationIds.length === 0) {
            this.$message.warning('请选择或导入需要调整的电站');
            return;
          }
          const peaksData = this.$refs.ykcPrice.saveVerifyOMP();
          const parameter = {
            stationIds,
            priceType: '0',
            configType: '0',
            periodType: '1',
            feeList: (peaksData.feeList || []).map(item => ({
              feeType: item.feeType,
              priceTypeName: item.priceTypeName,
              powerRate: item.powerRate,
            })),
            priceList: peaksData.priceList || [],
          };
          if (!parameter.priceList.length) {
            delete parameter.priceList;
          }
          chargeStrategy.batchAdjust(parameter).then(() => {
            this.$message.success('批量调整成功');
            callback && callback();
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .station-cascader {
    width: 100%;
    max-width: 390px;
  }
  .import-error {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 8px;
  }
  .import-info {
    color: #67c23a;
    font-size: 12px;
    margin-top: 8px;
  }
  .import-tip {
    color: #999;
    font-size: 12px;
    margin-top: 8px;
  }
</style>
